const primaryMain = '#162960';
const primaryMainOpacity = 'rgba(22, 41, 96, 0.9)';
const secondaryMain = '#F4B425';
const secondaryMainOpacity = 'rgba(244, 180, 37, 0.5)';
const secondaryLight = '#FADA98';
const tertiaryMain = '#162960';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
